"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _Image = _interopRequireWildcard(require("../../Image"));

var _default = function _default(props) {
  var _props$invert = props.invert,
      invert = _props$invert === void 0 ? false : _props$invert;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var src = (0, _react.useMemo)(function () {
    var src = props.src;

    if (!!src && src !== t('onmail.png')) {
      return src;
    }

    return (0, _Image.withThemeSrc)(props.invert ? t('onmail-light.png') : t('onmail.png'), t('onmail-light.png'));
  }, [props.src, invert]);
  return /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    className: "object-contain",
    src: src,
    alt: "onmail"
  });
};

exports["default"] = _default;
//# sourceMappingURL=AppLogo.js.map